import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ServicesPage from '../pages/services/page';
import ProductsPage from '../pages/products/page';
import ContactPage from '../pages/contact/page';
import NotFound from '../pages/NotFound';

// Product detail pages
import IntelligentFireAlarmControlPanelPage from '../pages/product-detail/page';
import CO2ExtinguishersPage from '../pages/co2-extinguishers/page';
import ControlValvesPage from '../pages/control-valves/page';
import DryChemicalExtinguishersPage from '../pages/dry-chemical-extinguishers/page';
import EmergencyExitSignsPage from '../pages/emergency-exit-signs/page';
import FirePumpSetsPage from '../pages/fire-pump-sets/page';
import FoamExtinguishersPage from '../pages/foam-extinguishers/page';
import ManualCallPointsPage from '../pages/manual-call-points/page';
import SmokeHeatDetectorsPage from '../pages/smoke-heat-detectors/page';
import SprinklerSystemsPage from '../pages/sprinkler-systems/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/products/intelligent-fire-alarm-control-panel',
    element: <IntelligentFireAlarmControlPanelPage />,
  },
  {
    path: '/products/co2-extinguishers',
    element: <CO2ExtinguishersPage />,
  },
  {
    path: '/products/control-valves',
    element: <ControlValvesPage />,
  },
  {
    path: '/products/dry-chemical-extinguishers',
    element: <DryChemicalExtinguishersPage />,
  },
  {
    path: '/products/emergency-exit-signs',
    element: <EmergencyExitSignsPage />,
  },
  {
    path: '/products/fire-pump-sets',
    element: <FirePumpSetsPage />,
  },
  {
    path: '/products/foam-extinguishers',
    element: <FoamExtinguishersPage />,
  },
  {
    path: '/products/manual-call-points',
    element: <ManualCallPointsPage />,
  },
  {
    path: '/products/smoke-heat-detectors',
    element: <SmokeHeatDetectorsPage />,
  },
  {
    path: '/products/sprinkler-systems',
    element: <SprinklerSystemsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
